export const ROOT = '/'
export const PUBLIC_RESOURCE = '/:publicResourceId'
